(() => {
  if (window.rhCartReviewsController) return;
  let revision = 0;
  let scheduled = false;
  const roots = new WeakSet();

  const reveal = (root) => {
    const count = root.querySelectorAll('.jm-review-item').length;
    if (count < 3) return false;
    const title = root.querySelector('.rh-cart-reviews__title');
    const settings = window.jdgmSettings || {};
    const nativeTitle = document.querySelector('#jdgm-cart-drawer-widget .jm-cart-mode-body__title');
    title.textContent = settings.widget_title || settings.all_reviews_widget_v2025_title || nativeTitle?.textContent || '';
    root.dataset.rhCartReviews = 'ready';
    root.classList.add('rh-cart-reviews--ready');
    root.hidden = false;
    return true;
  };

  const load = (root) => {
    if (roots.has(root)) return;
    const drawer = root.closest('cart-drawer');
    if (!drawer?.classList.contains('active')) return;
    roots.add(root);
    const mount = root.querySelector('.jdgm-all-reviews-widget-v2025');
    if (!mount) return;
    mount.dataset.entryPoint = 'all_reviews_widget_v2025.js';
    mount.dataset.entryKey = 'all-reviews-widget-v2025/main.js';
    const changes = new MutationObserver(() => {
      if (reveal(root)) changes.disconnect();
    });
    changes.observe(mount, {childList: true, subtree: true});

    let attempts = 0;
    const start = () => {
      const base = window.jdgm?.CDN_BASE_URL;
      if (!base) {
        attempts += 1;
        if (attempts < 50) setTimeout(start, 100);
        return;
      }
      const script = document.createElement('script');
      script.type = 'module';
      script.src = `${base}all_reviews_widget_v2025.js?rh_cart_drawer=${Date.now()}-${revision += 1}`;
      script.addEventListener('error', () => {
        root.dataset.rhCartReviews = 'error';
        changes.disconnect();
      }, {once: true});
      document.head.appendChild(script);
    };
    start();
  };

  const scan = () => {
    scheduled = false;
    document.querySelectorAll('#RhCartReviews[data-rh-cart-reviews="pending"]').forEach(load);
  };
  const queue = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  };

  const scope = document.getElementById('shopify-section-cart-drawer') || document.body;
  new MutationObserver(queue).observe(scope, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  document.addEventListener('jdgm.finishLoadingCore', queue);
  window.addEventListener('pageshow', queue);
  window.rhCartReviewsController = {scan: queue};
  scan();
})();
